import { ActionPicker as SharedActionPicker } from "@/components/ActionPicker";

import { useFinancialAidActionCatalog } from "../../api/hooks";
import type { PickerAction } from "../../types";

/** Financial-aid admin picker (OAC-441) — the shared ActionPicker wired to the
 * financialAids i18n namespace and the aid action-catalogue hook. */
export function ActionPicker(props: {
  value: PickerAction[];
  onChange: (next: PickerAction[]) => void;
  rowAction?: (action: PickerAction) => React.ReactNode;
  /** Read-only while a link change awaits a second administrator. */
  locked?: boolean;
  /** Ids the pending proposal would add, marked inline. */
  newIds?: ReadonlySet<string>;
}) {
  return (
    <SharedActionPicker
      {...props}
      ns="financialAids"
      useCatalog={useFinancialAidActionCatalog}
    />
  );
}
